export enum FormStatuses {
  available = 1,
  pending = 2,
  error = 3
}
